import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setUpdateUserInfo } from '../../redux/modules/auth';
import { mainApiUrl } from '../../utils/consts';
import AddressesComponent from '../ShoppingCart/AddressesComponent';

const select = state => {
  return {
    user: state.auth.user,
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setUpdateUserInfo: payload => dispatch(setUpdateUserInfo(payload))
  };
}


function ConnectedUserProfile(props) {

  const { user, userId } = props;
  const [phone, setPhone] = useState(user.cellPhone || '');
  const [validated, setValidated] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [loadingAddresses, setLoadingAddresses] = useState(true);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [deletingId, setDeletingId] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoadingAddresses(true);

    const addressesProm = await fetch(`${mainApiUrl}/addresses/user/${userId}`);
    const addressesResp = await addressesProm.json();

    if (addressesResp) setAddresses(addressesResp);

    setLoadingAddresses(false);
  };

  const deleteAddress = async id => {

    setDeletingId(id);

    const prom = await fetch(`${mainApiUrl}/addresses/delete`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id })
    });

    const json = await prom.json();

    if (json.success) getData();

    setDeletingId();
  };

  const handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;

    if (form.checkValidity()) {
      setUpdating(true);

      const updateProm = await fetch(`${mainApiUrl}/users/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          _id: userId,
          cellPhone: phone
        })
      });

      const updateJson = await updateProm.json();

      if (updateJson.success) alert('Datos actualizados.');
      else alert('Error. inténtalo de nuevo.');

      props.setUpdateUserInfo({ update: true });
      setUpdating(false);
    }
  };

  return (
    <div className="user-profile-component">
      <Container>
        <Row>
          <Col>
            <h3>Perfil</h3>
            <hr />
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group as={Col} xs={6}>
                  <Form.Label className="app-label">Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={true}
                    value={user.firstName}
                  />
                </Form.Group>
                <Form.Group as={Col} xs={6}>
                  <Form.Label className="app-label">Apellido</Form.Label>
                  <Form.Control
                    type="text"
                    disabled={true}
                    value={user.lastName}              
                  />
                </Form.Group>
                <Form.Group as={Col} xs={6}>
                  <Form.Label className="app-label">Teléfono</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Teléfono"
                    value={phone}
                    onChange={event => setPhone(event.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} xs={6}>
                  <Form.Label className="app-label">Correo electrónico</Form.Label>
                  <Form.Control
                    type="email"
                    value={user.email}
                    disabled={true}
                  />
                </Form.Group>
                <Form.Group as={Col} xs={6}>
                  <Form.Label className="app-label">Documento</Form.Label>
                  <Form.Control
                    type="email"
                    value={user.identification}
                    disabled={true}
                  />
                </Form.Group>

                <Col xs={12}>
                  <h3>Direcciones</h3>
                  <hr />
                </Col>
                {
                  loadingAddresses ?
                  <div style={{ width: 'fit-content', margin: '50px auto' }}>
                    <Spinner variant="info" animation="grow" />
                  </div> :
                  addresses.map((address, i) => {
                    return (
                      <Col sm={3} key={i}>
                        <div className="addressOption">
                          <fieldset>
                            {
                              deletingId === address._id ?
                              <span className="deleteAddress">
                                <Spinner variant="danger" animation="border" size="sm" />
                              </span> :
                              <i
                                onClick={() => deleteAddress(address._id)}
                                className="fa fa-trash deleteAddress"
                                style={{ color: 'firebrick', cursor: 'pointer' }}
                              />
                            }
                            <div><small><strong>{address.short}</strong></small></div>
                            <div className="addressText">{address.country}</div>
                            <div className="addressText">{address.state}</div>
                            <div className="addressText">{address.city}</div>
                            <div className="addressText">{address.area}</div>
                            <div className="addressText">{address.street}</div>
                            <div className="addressText">{address.extra}</div>
                            <div className="addressText">{address.phone}</div>
                          </fieldset>
                        </div>
                      </Col>
                    )
                  })
                }
                <Col sm={3}>
                  <Button variant="outline-primary" onClick={() => setShowAddressModal(true)} style={{ height: '100%', width: '100%' }}>
                    <span>Agregar dirección</span>
                  </Button>
                </Col>
                <Col xs={12}>
                  <hr />
                </Col>

                <Col xs={12}>
                  <Button className="app-button" style={{ display:' block', margin: '0 auto' }} type="submit">
                    {
                      updating ? <Spinner variant="warning" animation="border" size="sm" /> :
                      'Guardar cambios'
                    }
                  </Button>
                </Col>
                <br /><br /><br />

              </Form.Row>
            </Form>
          </Col>
        </Row>
      </Container>

      <Modal show={showAddressModal} onHide={() => setShowAddressModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Agrega una dirección de envío</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddressesComponent
            userId={props.userId}
            refreshAddresses={getData}
            closeModal={() => setShowAddressModal(false)}
          />
        </Modal.Body>
      </Modal>

    </div>
  );
}

const UserProfile = connect(select, mapDispatchToProps)(ConnectedUserProfile);

export default UserProfile;
